import React, { useState, useRef, useEffect } from "react";
import SendIcon from "./send.svg";
import EditIcon from "./images/edit-icon.svg";
import { fetchData, getAPIEndpoint } from "./Utils";

function Input(props) {
  const {
    data,
    leadArr,
    setMessages,
    messages,
    startTakingLead,
    threadId,
    token,
  } = props;
  const [disabled, setDisabled] = useState(data.value);
  const [error, setError] = useState("");
  const inputRef = useRef();

  const [inputValue, setInputValue] = useState(data.value);

  const doValidation = () => {
    let returnValue = true;
    setError("");
    switch (data.fld_name) {
      case "email":
        const filter =
          /^([a-z A-Z 0-9 _\.\-])+\@(([a-z A-Z 0-9\-])+\.)+([a-z A-z 0-9]{3,3})+$/;
        if (!filter.test(inputValue)) {
          inputRef.current.focus();
          setError("Please input correct email.");
          returnValue = false;
        }
        break;
      case "mobile":
        let pattern = /^\d{10}$/;
        if (!pattern.test(inputValue)) {
          inputRef.current.focus();
          setError("Phone nubmer is in 0123456789 format.");
          returnValue = false;
        }
        break;
      case "pin":
        let pincoderegex = /^\d{6}$/;
        if (!pincoderegex.test(inputValue)) {
          inputRef.current.focus();
          setError("Pin code should be 6 digits");
          returnValue = false;
        }
        break;
      default:
        break;
    }

    return returnValue;
  };

  const submitEvent = () => {
    console.log('i am here', messages, doValidation());
    if (doValidation()) {
      const allmessages = [...messages];
      setDisabled(true);
      fetchData(
        token,
        `${getAPIEndpoint(token, true)}/session/lead-save`,
        {
          session_id: threadId,
          [data.fld_name]: inputValue,
        },
        true
      );

      for (let index = 0; index < allmessages.length; index++) {
        const chat = allmessages[index];
        if (chat.lead && chat.fld_name === data.fld_name) {
          allmessages[index].value = inputValue;
          allmessages[index].required = "true";
        }
      }
      setMessages(allmessages);
      startTakingLead();
    }
  };

  const skipEvent = () => {
    setDisabled(true);
    const allmessages = [...messages];
    for (let index = 0; index < allmessages.length; index++) {
      const chat = allmessages[index];
      if (chat.lead && chat.fld_name === data.fld_name) {
        allmessages[index].required = "true";
      }
    }
    setMessages(allmessages);
    startTakingLead();
  };

  return (
    <div className="" place_holder>
      <div
        className={`form-control ${data.fld_name} input ${
          disabled ? "disabled" : ""
        }`}
      >
        {data.fld_name === "mobile" && (
          <span>
            <img src="/agent/flag.png" />
            &nbsp;+91
          </span>
        )}

        <input
          type={data.input_type}
          name={data.fld_name}
          placeholder={data.place_holder}
          value={inputValue}
          ref={inputRef}
          onChange={(e) => setInputValue(e.target.value)}
        />

        {disabled ? (
          <button
            type="submit"
            className="chatbox-message-submit input-edit"
            onClick={() => setDisabled(false)}
          >
            <img src={EditIcon} />
          </button>
        ) : (
          <button
            type="submit"
            className="chatbox-message-submit input-submit"
            onClick={() => submitEvent()}
          >
            <img src={SendIcon} />
          </button>
        )}
      </div>
      {error ? <span className="error">{error}</span> : null}
      {data.required === "false" ? (
        <div className="skip-button">
          <button
            type="submit"
            className="skip-submit"
            onClick={() => skipEvent()}
          >
            Skip
          </button>
        </div>
      ) : null}

      {/* <div className="form-control input">
        <input type="text" name="email" />
        <button type="submit" className="chatbox-message-submit input-submit">
          <img src={SendIcon} />
        </button>
      </div>

      <div className="form-control phone input">
        <span>
          <img src="/agent/flag.png" />
          &nbsp;+91
        </span>
        <input type="tel" name="email" />
        <button type="submit" className="chatbox-message-submit input-submit">
          <img src={SendIcon} />
        </button>
      </div> */}
    </div>
  );
}

export default Input;
